module.exports = __webpack_public_path__ + "Jp_NODjpCf2_Q0OCv/illo-couple-phone.svg";